

let observerOnceOff:IntersectionObserver;
const elementMapOnceOff = new WeakMap();

const options: IntersectionObserverInit = {
	threshold: 0.1,
};

const cb: IntersectionObserverCallback = (entries, observer) => {
	entries.forEach((entry) => {
		if (!entry.isIntersecting) return;
		const target = entry.target as HTMLDivElement;
		observer.unobserve(target);
		elementMapOnceOff.get(target)?.(target);
		elementMapOnceOff.delete(target);
	});
};

/**
 * Observe an element once and call a callback when it is in view.
 * @param element Any DOM element reference.
 * @param callback A function to be called only once when the element is in view.
 */
export const observeOnceOff = (element: HTMLElement, callback: (elm:HTMLDivElement) => void) => {
	if (!element) return;
	if (elementMapOnceOff.has(element)) return; // only one reference per element
	if (!observerOnceOff) observerOnceOff = new IntersectionObserver(cb, options); // avoiding SS assignment
	observerOnceOff.observe(element);
	elementMapOnceOff.set(element, callback);
};

/**
 * Unobserve an element.
 * @param element Any DOM element reference.
 */
export const unobserveOnceOff = (element: HTMLElement) => {
	if (!element) return;
	observerOnceOff.unobserve(element);
	elementMapOnceOff.delete(element);
}
